import Vue from "vue";
import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/auth";
import "firebase/analytics";
import "firebase/storage";

// firebase init
const config = {
  apiKey: "AIzaSyB9s3UJ3288t-2er_WvRqJ5I1f9JuHFhv8",
  authDomain: "cupsmachine.firebaseapp.com",
  databaseURL: "https://cupsmachine.firebaseio.com",
  projectId: "cupsmachine",
  storageBucket: "cupsmachine.appspot.com",
  messagingSenderId: "36593737491",
  appId: "1:36593737491:web:9727b894a7ea782ff804e6",
  measurementId: "G-HDP0ZLVYQL",
};
firebase.initializeApp(config);

firebase.analytics();
Vue.prototype.$analytics = firebase.analytics();

// firebase utils
const db = firebase.firestore();
const auth = firebase.auth();

export { db, auth, firebase };
